import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { htmlToPlainText } from '@vsolv/common/email/domain';
import { PortalService } from '@vsolv/packages/portal-config/web';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';
import { EmailTemplate } from '../../pages/email-templates/email-templates.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-settings-email-template-preview-dialog',
  templateUrl: './email-template-preview.dialog.html',
  standalone: false,
})
export class EmailTemplatePreviewDialog {
  private readonly cdr = inject(ChangeDetectorRef);

  @ViewChild(DialogComponent) dialog?: DialogComponent;

  protected template: EmailTemplate | null = null;
  protected emailButton: string | null = null;
  protected previewFormat: 'html' | 'text' = 'html';

  protected tenantLogo = this.portalSvc.config.logo;
  protected tenantName = this.portalSvc.config.brandName;

  private readonly emailButtons = new Map<string, string>([
    ['Distributor Created', 'View Distributor'],
    ['Batch Payment Failed', 'Retry payment'],
    ['Distributor Team Invite', 'Setup your account'],
    ['Distributor Team Member Added', 'Enter dashboard'],
  ]);

  constructor(private portalSvc: PortalService) {}

  open(template: EmailTemplate) {
    this.template = template;
    this.emailButton = this.emailButtons.get(template.type) ?? null;
    this.previewFormat = 'html';
    this.dialog?.open();
    // Dialog.open() only flushes the overlay view; refresh this host so projected
    // title/subject/body bind in the same turn (otherwise they wait for a later CD).
    this.cdr.detectChanges();
  }

  protected get contentPreviewHtml() {
    const content = this.template?.content ?? '';
    if (!this.emailButton) return content;
    return `${content}<div style="margin-top:24px;"><a href="#">${this.emailButton}</a></div>`;
  }

  protected get contentPreviewText() {
    return htmlToPlainText(this.contentPreviewHtml);
  }

  protected setPreviewFormat(value: unknown) {
    if (value === 'html' || value === 'text') this.previewFormat = value;
  }
}
